import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

/**
 * Badge — farebné indikátory stavu (Tandem DESIGN_SYSTEM.md sekcia
 * "Stavy zákaziek"). Varianty mapujú na konkrétne stavy.
 */
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        // Stavy zákaziek (DESIGN_SYSTEM.md)
        ponuka: "border-transparent bg-yellow-100 text-yellow-800",
        // Prijatá, pripravuje sa — medzi žltou ponukou a oranžovou výrobou (KOLO 204)
        v_priprave: "border-transparent bg-sky-100 text-sky-800",
        vo_vyrobe: "border-transparent bg-orange-100 text-orange-800",
        dokoncena: "border-transparent bg-emerald-100 text-emerald-800",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps): JSX.Element {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
